import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NewsItem } from '../../../interfaces/newsitem';
import { CommonModule } from '@angular/common';
import { NewsitemService } from '../../../services/newsitem.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NewsitemEditComponent } from '../newsitem-edit/newsitem-edit.component';
import { Observable } from 'rxjs';
import { Permission } from '../../../interfaces/permission';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-newsitem-card',
  imports: [MatDialogModule, MatIconModule, MatCardModule, MatCheckboxModule, CommonModule],
  templateUrl: './newsitem-card.component.html',
  styleUrl: './newsitem-card.component.scss'
})
export class NewsitemCardComponent {
  canEditNewsItem$: Observable<boolean>;

  constructor(
    private newsItemService: NewsitemService,
    private snackBar: MatSnackBar,
    private readonly dialog: MatDialog,
    private readonly authService: AuthService
  ) {
    this.canEditNewsItem$ = this.authService.hasPermissions$(Permission.NEWSITEM_EDIT);
  }
  @Input() item!: NewsItem;
  @Input() readonly = true;

  // Output event emitter to notify the parent component of deletion
  @Output() itemDeleted = new EventEmitter<NewsItem>();

  toggleHidden() {
    const hiddenNewsItem = this.item;
    hiddenNewsItem.hide = !hiddenNewsItem.hide;
    this.newsItemService.updateNewsItem(hiddenNewsItem).subscribe({
      next: (response) => {
        this.item = response;
        if (hiddenNewsItem.hide) {
          this.showNotification(`News item with id: ${this.item.id} hidden`);
        } else {
          this.showNotification(`News item with id: ${this.item.id} visible`);
        }
      },
      error: (err) => {
        this.showNotification('Failed to hide news item. Please try again.');
      }
    });
  }

  editNewsItem() {
    const dialogRef = this.dialog.open(NewsitemEditComponent, {
      data: { item: this.item } // Pass the item data here
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Handle the result from the dialog if needed
        this.item = result;
      }
    });
  }

  deleteNewsItem() {
    this.newsItemService.deleteNewsItem(this.item.id).subscribe({
      next: (response) => {
        console.log('News Item deleted:', response);
        this.showNotification(`News item with id: ${this.item.id} deleted`);

        // Emit the event with the deleted item id
        this.itemDeleted.emit(this.item);
      },
      error: (err) => {
        this.showNotification('Failed to delete news item. Please try again.');
      }
    });
  }

  showNotification(message: string, action: string = 'Close'): void {
    this.snackBar.open(message, action, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }
}
